import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "@/i18n/SiteContext";
import { Reveal } from "@/components/site/Reveal";
import { DESTINATIONS } from "@/lib/images";

/* Editorial 5-tile grid: one large tile + four smaller ones */
export const DestinationsGrid = ({ tours = [] }) => {
  const { t } = useSite();
  const count = (k) => tours.filter((x) => x.destination === k).length;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2 gap-4 md:gap-5 lg:h-[640px]" data-testid="destinations-grid">
      {DESTINATIONS.map((d, i) => {
        const n = count(d.key);
        const big = i === 0;
        const wide = !big && DESTINATIONS.length === 4 && i === DESTINATIONS.length - 1;
        return (
          <Reveal key={d.key} delay={i * 0.06} y={20} className={`${big ? "sm:col-span-2 lg:row-span-2" : ""} ${wide ? "sm:col-span-2 lg:col-span-2" : ""} h-full`}>
            <Link
              to={`/tours?destination=${d.key}`}
              data-testid={`destination-tile-${d.key}`}
              className={`group relative block h-full ${big ? "min-h-[420px]" : "min-h-[260px] lg:min-h-0"} rounded-2xl overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sea focus-visible:ring-offset-2 focus-visible:ring-offset-ivory`}
            >
              <div className="img-zoom absolute inset-0">
                <img src={d.image} alt={t(`dest.${d.key}`)} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-ocean/90 via-ocean/45 to-ocean/5" />
              <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-ivory/15 backdrop-blur-md border border-ivory/30 flex items-center justify-center text-ivory opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100" style={{ transition: "opacity .25s ease" }}>
                <ArrowUpRight size={17} />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-7">
                <p className="text-[10px] font-medium tracking-[0.3em] uppercase text-ivory/85" data-testid={`destination-count-${d.key}`}>
                  {n === 1 ? t("dest.tour1") : t("dest.tours", { n })}
                </p>
                <h3 className={`font-serif text-ivory mt-2 leading-tight ${big ? "text-3xl md:text-5xl" : "text-2xl"}`}>{t(`dest.${d.key}`)}</h3>
                <p className={`mt-2 text-sm text-ivory/80 leading-relaxed ${big ? "max-w-md" : "line-clamp-2"}`}>{t(`dest.${d.key}D`)}</p>
              </div>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
};
